import {
    Component,
    OnInit,
    OnDestroy,
    ViewEncapsulation
} from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import {
    Router,
    NavigationStart,
    NavigationEnd
} from '@angular/router';

import { filter, tap } from 'rxjs/operators';

import { LoaderService } from '../../core/upgraded-providers';
import { merge } from 'rxjs';

declare const angular: angular.IAngularStatic;

@Component({
    selector: 'app-market',
    templateUrl: './base.component.pug',
    styleUrls: ['./base.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class BaseComponent implements OnInit, OnDestroy {

    private subscribers$;

    constructor(
        private _router: Router,
        private _loaderService: LoaderService
    ) {
        const navigationStart$ = this._router.events
            .pipe(filter(e => e instanceof NavigationStart))
            .pipe(tap((data) => this._loaderService.loadingCnt++));

        const navigationEnd$ = this._router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .pipe(tap((data) => this._loaderService.loadingCnt--));

        this.subscribers$ = merge(navigationStart$, navigationEnd$)
            .subscribe();
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.subscribers$
            .unsubscribe();
    }
}

angular.module('app').directive('app2Market',
    downgradeComponent({component: BaseComponent}));
